/**
 * @generated SignedSource<<4c4abbfc511dda1fb14b844c0b388995>>
 * @relayHash ca950652c375632e8e3242fc2e8e313a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceContributorsMacroParametersModel = {
  contentType?: string | null | undefined;
  include?: string | null | undefined;
  label?: string | null | undefined;
  labels?: string | null | undefined;
  limit?: number | null | undefined;
  mode?: string | null | undefined;
  name?: string | null | undefined;
  noneFoundMessage?: string | null | undefined;
  order?: string | null | undefined;
  page?: string | null | undefined;
  publishDate?: string | null | undefined;
  reverse?: boolean | null | undefined;
  scope?: string | null | undefined;
  showAnonymous?: boolean | null | undefined;
  showCount?: boolean | null | undefined;
  showLastTime?: boolean | null | undefined;
  space?: string | null | undefined;
  spaces?: string | null | undefined;
};
export type useContributorsDataQuery$variables = {
  contentId?: string | null | undefined;
  contentStatus?: ReadonlyArray<string | null | undefined> | null | undefined;
  contributorsMacroParameters?: ConfluenceContributorsMacroParametersModel | null | undefined;
};
export type useContributorsDataQuery$data = {
  readonly singleContent: {
    readonly contributorsMacro: {
      readonly authorRankingList: ReadonlyArray<{
        readonly comments: number | null | undefined;
        readonly edits: number | null | undefined;
        readonly fullNameString: string | null | undefined;
        readonly idString: string | null | undefined;
        readonly labels: number | null | undefined;
        readonly lastCommentTime: AGG$Long | null | undefined;
        readonly lastEditTime: AGG$Long | null | undefined;
        readonly lastLabelTime: AGG$Long | null | undefined;
        readonly watches: number | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useContributorsDataQuery = {
  response: useContributorsDataQuery$data;
  variables: useContributorsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentStatus"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contributorsMacroParameters"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "contentStatus"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "contributorsMacroParameters",
            "variableName": "contributorsMacroParameters"
          }
        ],
        "concreteType": "ConfluenceContributorsRankings",
        "kind": "LinkedField",
        "name": "contributorsMacro",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceAuthorRanking",
            "kind": "LinkedField",
            "name": "authorRankingList",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "idString"
              },
              {
                "kind": "ScalarField",
                "name": "fullNameString"
              },
              {
                "kind": "ScalarField",
                "name": "edits"
              },
              {
                "kind": "ScalarField",
                "name": "comments"
              },
              {
                "kind": "ScalarField",
                "name": "labels"
              },
              {
                "kind": "ScalarField",
                "name": "watches"
              },
              {
                "kind": "ScalarField",
                "name": "lastEditTime"
              },
              {
                "kind": "ScalarField",
                "name": "lastCommentTime"
              },
              {
                "kind": "ScalarField",
                "name": "lastLabelTime"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContributorsDataQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContributorsDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ca950652c375632e8e3242fc2e8e313a",
    "id": "d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3",
    "metadata": {},
    "name": "useContributorsDataQuery",
    "operationKind": "query",
    "text": "query useContributorsDataQuery($contentId:ID,$contentStatus:[String],$contributorsMacroParameters:ConfluenceContributorsMacroParametersModel){singleContent(id:$contentId,status:$contentStatus){id,contributorsMacro(contributorsMacroParameters:$contributorsMacroParameters){authorRankingList{idString,fullNameString,edits,comments,labels,watches,lastEditTime,lastCommentTime,lastLabelTime}}}}"
  }
};
})();

(node as any).hash = "2b1ea1963eb971919228dd0de7168930";

export default node;
